import { ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { useSession } from "@/context/Session";
import { useApi, errMsg } from "@/lib/api";

export function OrgSwitcher({ testid = "org-switcher" }: { testid?: string }) {
  const { me } = useSession();
  const api = useApi();
  if (!me.orgs || me.orgs.length < 2) return null;
  const change = async (id: string) => {
    try { await api.put("/me/org", { org_id: id }); sessionStorage.setItem("smboi-org", id); window.location.assign("/chat"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <label className="relative inline-flex items-center gap-1 text-xs faint hover:text-[var(--text-primary)] cursor-pointer max-w-[14rem]">
      <select className="appearance-none bg-transparent pr-4 truncate cursor-pointer outline-none" style={{ width: `calc(${(me.org?.name || "").length * 0.82}ch + 1.25rem)`, maxWidth: "14rem" }} value={me.org?.id} onChange={(e) => change(e.target.value)} data-testid={testid}>
        {me.orgs.map((o: { id: string; name: string }) => <option key={o.id} value={o.id}>{o.name}</option>)}
      </select>
      <ChevronDown size={12} className="absolute right-0 pointer-events-none" />
    </label>
  );
}
